import { FounderContext } from "../context/FounderContext";
import { useContext } from "react";

export const useFounderContext = () => {
    const context = useContext(FounderContext);

    if (!context) {
        return Error('useFounderContext must be used inside an FounderContextProvider');
    };

    return context;
};